import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../../components/ErpTemplate';
import api from '../../../services/api';
import { useHistory } from 'react-router-dom';
import ReactSelect from '../../../components/ReactSelect';
import { extract } from '../../../util/util';
import SaveButton from '../../../components/SaveButton';
import { toast } from 'react-toastify';
import { FinField, FinInput } from '../../../components/FinField';
import '../../../css/financeiro-parcela-pagar.css';

export default function CadastroPlanoConta({ match }) {
    const id = match.params.id;
    const token = localStorage.getItem('token');
    const [dados, setDados] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const history = useHistory();

    const buscar = () => {
        if (id) {
            api({ method: "get", action: '/financeiroPlanoConta/' + id, token: token })
                .then(response => {
                    var dadosRecebidos = extract({
                        jsonLaravel: response.data.data,
                        chaves: ['superior', 'grupodre']
                    });
                    setDados(dadosRecebidos);
                })
                .catch(() => {});
        }
    };

    const salvar = () => {
        if (isSubmitting) return;
        setIsSubmitting(true);
        if (id) {
            api({ method: 'put', action: '/financeiroPlanoConta/' + id, token: token, data: dados })
                .then(() => { toast.success("Dados salvos com sucesso!"); history.push("/financeiroPlanoConta"); })
                .catch(error => { toast.error('Erro ao salvar: ' + (error.response && error.response.data && error.response.data.error ? error.response.data.error : error.message || '')); })
                .finally(() => setIsSubmitting(false));
        } else {
            api({ method: 'post', action: '/financeiroPlanoConta', token: token, data: dados })
                .then(() => { toast.success("Dados salvos com sucesso!"); history.push("/financeiroPlanoConta"); })
                .catch(error => { toast.error('Erro ao salvar: ' + (error.response && error.response.data && error.response.data.error ? error.response.data.error : error.message || '')); })
                .finally(() => setIsSubmitting(false));
        }
    };

    useEffect(() => {
        document.querySelector("#nome") && document.querySelector("#nome").focus();
        buscar();
    },
    // eslint-disable-next-line
    []);

    return (
        <ErpTemplate>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div><h1 className="fin-pp__title">Conta Contábil</h1></div>
                </div>

                <form onSubmit={(e) => { salvar(); e.preventDefault(); }}>
                    <div className="fin-pp__card" style={{ padding: '20px 24px', marginBottom: 16 }}>
                        <div className="fin-pp__filters">
                            <FinField label="Situação">
                                <ReactSelect
                                    value={{ value: dados.situacaoRegistro, label: dados.nomeSituacaoRegistro }}
                                    onChange={e => setDados({ ...dados, situacaoRegistro: e.value, nomeSituacaoRegistro: e.label })}
                                    options={[
                                        { value: 'ativo', label: 'Ativo' },
                                        { value: 'inativo', label: 'Inativo' },
                                    ]}
                                />
                            </FinField>
                            <FinField label="Código">
                                <FinInput
                                    id="codigo"
                                    value={dados.codigo || ''}
                                    onChange={e => setDados({ ...dados, codigo: e.target.value })}
                                />
                            </FinField>
                            <FinField label="Superior" grow>
                                <ReactSelect
                                    value={{ value: dados.superior, label: dados.nomeSuperior }}
                                    onChange={e => setDados({ ...dados, superior: e.value, nomeSuperior: e.label })}
                                    loadOptions={(input) => {
                                        return api({
                                            method: 'get',
                                            action: '/financeiroPlanoConta',
                                            token: token,
                                            params: { nome: input, tipo: "2", situacaoRegistro: "ativo" }
                                        })
                                            .then(response => response.data.data.map(registro => ({
                                                value: registro.id,
                                                label: registro.caminho + '-' + registro.nome
                                            })))
                                            .catch(() => {});
                                    }}
                                />
                            </FinField>
                            <FinField label="Nome" full>
                                <FinInput
                                    id="nome"
                                    value={dados.nome || ''}
                                    onChange={e => setDados({ ...dados, nome: e.target.value })}
                                />
                            </FinField>
                            <FinField label="Tipo">
                                <ReactSelect
                                    value={{ value: dados.tipo, label: dados.nomeTipo }}
                                    onChange={e => setDados({ ...dados, tipo: e.value, nomeTipo: e.label })}
                                    options={[
                                        { value: 1, label: 'Analítica' },
                                        { value: 2, label: 'Sintética' }
                                    ]}
                                />
                            </FinField>
                            <FinField label="Grupo DRE" grow>
                                <ReactSelect
                                    value={{ value: dados.grupodre, label: dados.nomeGrupodre }}
                                    onChange={e => setDados({ ...dados, grupodre: e.value, nomeGrupodre: e.label })}
                                    loadOptions={(input) => {
                                        return api({
                                            method: 'get',
                                            action: '/financeiroGrupoDre',
                                            token: token,
                                            params: { nome: input }
                                        })
                                            .then(response => response.data.data.map(registro => ({
                                                label: (registro.operacao === 1 ? '(+) ' : '(-) ') + registro.nome,
                                                value: registro.id
                                            })))
                                            .catch(() => {});
                                    }}
                                />
                            </FinField>
                        </div>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <SaveButton isSubmitting={isSubmitting} />
                    </div>
                </form>
            </div>
        </ErpTemplate>
    );
}
